export const SUPPORTED_LANGUAGES = {
  es: {
    id: "es",
    locale: "es-ES", // 👈 Guardamos el formato largo aquí por si acaso
    name: "Español",
    region: "España",
    flag: "🇪🇸",
    countryCode: "ES",
  },
  en: {
    id: "en",
    locale: "en-GB",
    name: "English",
    region: "UK",
    flag: "🇬🇧",
    countryCode: "GB",
  },
  it: {
    id: "it",
    locale: "it-IT",
    name: "Italiano",
    region: "Italia",
    flag: "🇮🇹",
    countryCode: "IT",
  },
  // fr: {
  //   id: "fr",
  //   locale: "fr-FR",
  //   name: "Français",
  //   region: "France",
  //   flag: "🇫🇷",
  //   countryCode: "FR",
  // },
} as const;

export type LanguageCode = keyof typeof SUPPORTED_LANGUAGES; // "es" | "en" | "it" | "fr"

// Utility para sacar el array si lo necesitas (por ejemplo para validaciones)
export const LANGUAGE_CODES = Object.keys(
  SUPPORTED_LANGUAGES,
) as LanguageCode[];
